import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './app'

const element = document.querySelector(
  '#custom-sizes-CA49E41E-04D2-4626-ABF9-A10B3AD8935E'
)

if (!element) {
  throw new Error('Missing product elements')
}

ReactDOM.render(<App />, element)
